import Text from "../Text";
import { fontSizes } from "../../constants/constants";
import InputFieldFuctions from "./index.function";
const InputField = ({
  type,
  name,
  placeholder,
  onChange,
  icon,
  isPassword = false,
  isConfirmPassword = false,
  iconPasswordVisible,
  iconPasswordHidden,
  iconStyle,
  cardIcon,
  errors,
  is_ForgotPassword,
}) => {
  const {
    TextWeight,
    navigate,
    isPasswordVisible,
    handleFocusInput,
    togglePasswordVisibility,
    inputRef,
  } = InputFieldFuctions();
  return (
    <>
      <div className="relative">
        <input
          className="text-sm lg:text-lg mb-1 px-12 lg:px-14 2xl:px-20  font-ralewaySemiBold text-customBlack  w-full py-5 rounded-xl focus:outline-none transition duration-300 delay-100 focus:ring-2 focus:ring-primary shadow-custom-gray"
          type={isPassword ? (isPasswordVisible ? "text" : "password") : type}
          name={name}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          ref={inputRef}
        />
        {icon && (
          <img
            onClick={handleFocusInput}
            className={`absolute left-5 2xl:left-8 top-1/2 transform -translate-y-1/2 ${iconStyle}`}
            src={icon}
            alt={`${name} icon`}
          />
        )}
        {cardIcon && (
          <img
            onClick={handleFocusInput}
            className={`absolute right-6 top-1/2 transform -translate-y-1/2  h-6 w-10 sm:w-7 sm:h-4 2xl:right-8 2xl:w-9 2xl:h-8`}
            src={cardIcon}
            alt={`${name} cardIcon`}
          />
        )}
        {(isPassword || isConfirmPassword) && (
          <img
            className="absolute right-5 top-1/2 transform -translate-y-1/2 w-5 h-5 sm:w-5 sm:h-5 lg:h-6 lg:w-7 cursor-pointer 2xl:right-8 2xl:w-8 2xl:h-7"
            src={isPasswordVisible ? iconPasswordVisible : iconPasswordHidden}
            alt={isPasswordVisible ? "Show password" : "Hide password"}
            onClick={togglePasswordVisibility}
          />
        )}
      </div>
      <div
        className={`${
          is_ForgotPassword
            ? "flex justify-between items-start"
            : "flex justify-start items-start"
        }`}
      >
        <div>
          {errors?.[name] && (
            <Text
              text={errors[name].message}
              color="text-red"
              size={fontSizes.h16}
              textWeight={TextWeight.Onest_regular}
              className={"pl-6 sm:pl-6 lg:pl-8"}
              isTruncate={false}
            />
          )}
        </div>
        {is_ForgotPassword && (
          <Text
            text="Forgot Password"
            color="text-black hover:text-primary"
            size={fontSizes.h18}
            textWeight={TextWeight.Raleway_SemiBold}
            className="cursor-pointer hover:underline pr-6 sm:pr-6 lg:pr-8"
            onClick={() => {
              navigate("/forgetPassword");
            }}
          />
        )}
      </div>
    </>
  );
};

export default InputField;
